// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__35g23","info":"Note_info__1pSSE","note":"Note_note__8xl29","actions":"Note_actions__3rRyW"};